import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 350 }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  submit(event) {
    clearTimeout(this.timeout)

    if (event?.type === "input") {
      this.timeout = setTimeout(() => this.#submit(), this.delayValue)
    } else {
      this.#submit()
    }
  }

  #submit() {
    this.element.requestSubmit()
  }
}
